import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

const Section = () => (
	<Stack space="space.050">
		<Skeleton borderRadius="8px" isShimmering={true} width="100%" height={token('space.200')} />
		<Skeleton borderRadius="8px" isShimmering={true} width="100%" height={token('space.200')} />
		<Skeleton borderRadius="8px" isShimmering={true} width="33%" height={token('space.200')} />
	</Stack>
);

export const LoadingSkeleton = (): React.JSX.Element => {
	return (
		<Stack space="space.400">
			<Section />
			<Section />
			<Section />
		</Stack>
	);
};
